import { render } from "./CheckBox.vue?vue&type=template&id=1f4a9b6e&scoped=true&ts=true&lang=pug"
import script from "./CheckBox.vue?vue&type=script&lang=ts"
export * from "./CheckBox.vue?vue&type=script&lang=ts"

import "./CheckBox.vue?vue&type=style&index=0&id=1f4a9b6e&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/WP Darts/Admin Webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4a9b6e"]])

export default __exports__